import { AllDataRoomFoldersQuery, FileType } from "@/src/graphql/generated";
import { getDataRoomIndex } from "@/src/utils/getDataRoomIndex";

export type IndexRow = {
  depth: number;
  type: "folder" | "file";
  name: string;
  index: string;
  fileType?: FileType;
  url: string;
};

type ExportFolder =
  AllDataRoomFoldersQuery["deal"]["dataRoom"]["allFolders"][0];

type ExportFile = ExportFolder["files"][0];

export type ExportFolderWrapper = {
  folder: ExportFolder;
  folders: ExportFolderWrapper[];
  files: ExportFile[];
};

export function flattenFolderHierarchy(
  hierarchy: ExportFolderWrapper[],
  dealId: string,
  indexingEnabled: boolean,
  origin: string,
  depth = 0,
): IndexRow[] {
  const rows: IndexRow[] = [];

  for (const wrapper of hierarchy) {
    const folder = wrapper.folder;
    const folderName = folder.name ? folder.name : "Home";

    rows.push({
      depth,
      type: "folder",
      name: folderName,
      index: indexingEnabled
        ? getDataRoomIndex(
            folder.index?.sortIndex,
            folder.parentFolders,
            "folder",
          )
        : "",
      url: `${origin}/deal/${dealId}/documents/folder/${folder.id}`,
    });

    rows.push(
      ...flattenFolderHierarchy(
        wrapper.folders,
        dealId,
        indexingEnabled,
        origin,
        depth + 1,
      ),
    );

    for (const file of wrapper.files) {
      rows.push({
        depth: depth + 1,
        type: "file",
        name: file.name,
        index: indexingEnabled
          ? getDataRoomIndex(
              file.index?.sortIndex,
              file.parentFolders,
              "file",
            )
          : "",
        fileType: file.fileType,
        url: `${origin}/deal/${dealId}/documents/folder/${file.folderId}/file/${file.id}`,
      });
    }
  }

  return rows;
}
